import type { AxiosResponse } from 'axios';
import { ApiService } from '@/services/api';

type URLType = { url: string };

type UploadProps = {
  fileUpload: (id: string, data: FormData) => Promise<AxiosResponse<URLType>>;
};

export default function UploadService(): UploadProps {
  const { api } = ApiService();
  function fileUpload(id: string, data: FormData) {
    return api.post<URLType>(`/fintech/v1/clients/${id}/documents`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  return { fileUpload };
}
